/**
 * @description defines routes for the FAQ page
 */

import React from 'react';

import KnowledgeCenter from '@seccon/pages/knowledgeCenter';

export default [
  {
    path: '/knowledgeCenter/index',
    element: (
      <KnowledgeCenter />
    )
  }
];
